import { useQuery } from '@tanstack/react-query';

// The server-rendered tab ages from page load, not from whenever react-query
// creates the cache entry.
const pageLoadedAt = Date.now();

/**
 * One profile tab's data. The tab the page rendered arrives in props and is
 * used as is; any other tab is fetched the first time you open it. A tab this
 * profile does not have is never fetched, because the endpoint would refuse it.
 */
export function useProfileTab(
   userid: number,
   tabName: string,
   renderedTab: { data?: unknown } | undefined
) {
   return useQuery({
      queryKey: [`users/${userid}/profile-tab/${tabName}`],
      initialData: renderedTab?.data ?? undefined,
      initialDataUpdatedAt: pageLoadedAt,
      staleTime: 60_000,
      enabled: renderedTab !== undefined,
   });
}
